import { render, staticRenderFns } from "./VOCrelevance.vue?vue&type=template&id=f5c415b2&scoped=true&"
import script from "./VOCrelevance.vue?vue&type=script&lang=js&"
export * from "./VOCrelevance.vue?vue&type=script&lang=js&"
import style0 from "./VOCrelevance.vue?vue&type=style&index=0&id=f5c415b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c415b2",
  null
  
)

export default component.exports